import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入 ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入 axios
import axios from 'axios'
import logoImg from '@/assets/logo.png'

// 配置接口根地址（使用相对路径，配合代理）


// 修复 ElementUI clickoutside setAttribute 空指针报错
const clickOutside = require('element-ui/lib/utils/clickoutside')
const originHandler = clickOutside.documentHandler

clickOutside.documentHandler = function(e) {
  try {
    return originHandler.call(this, e)
  } catch (err) {
    // 静默捕获异常，不中断程序
  }
}

axios.defaults.withCredentials = true
Vue.prototype.$axios = axios

// 媒体资源默认图标：资源自身没有图片、或图片加载失败时使用
const DEFAULT_MEDIA_ICON = 'https://www.meijiematou.com/logo.png'
// 回退顺序：业务图 → 默认图标 → 站内 logo（默认图标也加载失败时再退一级，避免出现裂图）
const imgFallbackChain = [DEFAULT_MEDIA_ICON, logoImg]
Vue.prototype.$fallbackLogo = DEFAULT_MEDIA_ICON
Vue.prototype.$setImgFallback = function (e) {
  const el = e && e.target
  if (!el) return
  const step = Number(el.dataset.fallbackStep || 0)
  if (step >= imgFallbackChain.length) return
  el.dataset.fallbackStep = step + 1
  el.src = imgFallbackChain[step]
}

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

